<template>
    <div class="container">
      <el-carousel
        trigger="click"
        arrow="never"
        height="300px"
      >
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img4.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">平铺电站</div>
                <!-- <div class="desc">
                    系统对巡检区域进行二维建模生成全景图，将该区域的光伏情况以更宏观的形式展示出来，并生成精细化图片。
                </div> -->
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img5.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">斜铺电站</div>
                <!-- <div class="desc">
                    在计划飞行区域内绘制想要飞行的路线，系统自动生成航线，无需导入航线文档，还可及时对航线参数进行修改。
                </div> -->
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img6.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">山地电站</div>
                <!-- <div class="desc">
                    可提前在平台上制定任务，包括临时任务和周期性任务。将任务与航线关联，无人机按照规定航线和时间自主飞行巡检。
                </div> -->
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img7.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">单轴跟踪</div>
                <!-- <div class="desc">
                    无人机按照规划的航线和任务，自动出库飞行巡检。航飞视频实况直播，遇突发状况，还可对无人机实现一键返航。
                </div> -->
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/xjjl_img8.png" alt="">
            </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">多轴跟踪</div>
                <!-- <div class="desc">
                    热红外双光检测，可识别点状热斑、竖条状热斑、横条状热斑、全红热斑、厚积尘、遮挡、鸟粪、破损等8大类型缺陷。
                </div> -->
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style lang="stylus" scoped>
  /deep/.el-carousel__button {
      background-color: #E0E0E0;
  }
  /deep/.el-carousel__indicator.is-active button {
      background-color:#2372E9;
  }
  /deep/.el-carousel__indicators--horizontal {
    width:270px !important;
    display:flex;
    justify-content:center;
  }
    .content-row {
              display:flex;
              flex-direction: column;
              margin-bottom:4rem;
              >div {
                  flex:1;
              }
              .img-wrap {
                  display:flex;
                  justify-content: center;
                  align-items: center;
              }
              .row-left {
                  .img-wrap {
                      max-height:314px !important;
                      overflow:hidden;
                      display:flex;
                      justify-content: center;
                      align-items: center;
                  }
                  img {
                      width:100%;
                  }
              }
              .block-text {
                  padding:17px 0 10px;
                  .title {
                      color:#2372E9;
                      margin-bottom:10px;
                      font-size:18px;
                      text-align:center;
                  }
                  .desc {
                      color:#333333;
                      line-height:30px;
                      font-size:1.25rem;
                  }
              }
          }
  </style>
  